import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const WarehouseLocationExpanded = ({ fulfillmentPlanId, fulfillmentPlanItemId = '', isExpanded }) => {
  const items = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'items',
    }),
  );

  const locations = items.reduce((acc, orderItem) => {
    if (orderItem.warehouseLocation && acc.indexOf(orderItem.warehouseLocation) === -1) {
      acc.push(orderItem.warehouseLocation);
    }

    return acc;
  }, []);

  if (locations.length === 0) {
    return '';
  }

  const item = items.find((i) => i.fulfillmentPlanItemId === fulfillmentPlanItemId);

  return !isExpanded && locations.length > 1 ? (
    <FormattedMessage {...messages.numberOfItems} values={{ numberOfItems: items.length }} />
  ) : (
    (item?.warehouseLocation ?? '')
  );
};

WarehouseLocationExpanded.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  fulfillmentPlanItemId: PropTypes.string,
  isExpanded: PropTypes.bool.isRequired,
};

export const WarehouseLocation = {
  getMessageDescriptor: () => messages.warehouseLocation,
  id: 'warehouse-location',

  render: (data, { isExpanded = false } = {}) => {
    return (
      <WarehouseLocationExpanded fulfillmentPlanId={data.id} fulfillmentPlanItemId={data.fulfillmentPlanItemId} isExpanded={isExpanded} />
    );
  },
};
